import React, { ReactElement } from "react";
import styles from "./styles.module.css";
import clsx from "clsx";

interface CardComponentProps {
  borderType?: 'Sm' | 'Md' | 'Lg'; 
  children?: ReactElement;
  className?: string;
}

const CardComponent: React.FC<CardComponentProps> = ({ borderType = 'Md', children, className }) => {
  return (
    <div className={clsx(styles.cardBox, styles[`cardBox${borderType}`], className)}>
      {children}
    </div>
  );
};

export default CardComponent;
